import script from "./PartyManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./PartyManagement.vue?vue&type=script&setup=true&lang=js"

import "./PartyManagement.vue?vue&type=style&index=0&id=730f52cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-730f52cc"]])

export default __exports__